<template>
  <div class='wrapper-page folder_show shared-folder-show'>
    <div class='container-fluid'>
      <h1 class='page-title'>
        {{ fullName }} > <strong>{{ folderName }}</strong>
      </h1>
      <div class="nav-tabs-wrapper">
        <ul role="tablist" class="nav nav-tabs">
          <li class="nav-item">
            <router-link :to="{ name: 'shared_folder_show', params: { id: $route.params.id } }" class="nav-link">
              {{ $t('folder_show.tabs.files') }}
            </router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name: 'shared_folder_checklist', params: { id: $route.params.id } }" class="nav-link active">
              {{ $t('folder_show.tabs.checklist') }}
            </router-link>
          </li>
        </ul>
      </div>

      <div class="tab-content">
        <shared_checklist v-if='$route.params.id' :folder-id="this.$route.params.id" :permission='permission' @reload="loadSharedFolder" />
      </div>
    </div>
  </div>
</template>

<script>

import shared_checklist from "@/components/checklists/shared_checklist";

export default {
  components: {
    shared_checklist,
  },

  created() {
    this.loadSharedFolder()
    this.store.sendMetrics({name: 'shared_folder_checklist', params: this.$route.params, path: this.$route.fullPath})
  },
  watch: {
    id() {
      this.loadSharedFolder()
    },
  },
  computed: {
    sharedFolder() {
      return this.state.sharedFolder || {}
    },

    records() {
      if (!this.state.sharedFolder)
        return []

      return this.state.sharedFolder.records.filter(r => r.id !== null)
    },

    permission() {
      if (this.state.sharedFolder) {
        if(this.state.sharedFolder.share_invite) {
          return this.state.sharedFolder.share_invite.invite_type
        }
      }
    },
    folderName() {
      if (this.state.sharedFolder) {
        return this.state.sharedFolder.name
      }
    },
    fullName() {
      if(this.state.sharedFolder) {
        if(this.state.sharedFolder.user) {
          return this.state.sharedFolder.user.full_name
        }
      }
    },

  },
  methods: {
    loadSharedFolder() {
      this.store.getSharedFolder(this.$route.params.id)
    },
  }
}
</script>
<style lang="sass" scoped>
.persf
  float: left
  margin-top: 14px
  margin-left: 10px
  i
    color: #ffb429
    font-size: 25px
    margin-right: 7px
  img
    vertical-align: top
    margin-right: 7px
    cursor: pointer
.show-hide-columns
  margin-left: 0
</style>
